import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { EligibilityFileJobLogExtension as EligibilityFileJobLogModel } from 'tio-data/data/resources/eligibility-file-job-log.ext';
import type { Store } from '@warp-drive/core';

export default class AuthenticatedAdminEligibilityFilesShowRoute extends Route {
  @service declare store: Store;

  async model({ eligibility_file_job_log_id }: { eligibility_file_job_log_id: string }) {
    const { content } = (await this.store.request(
      findRecord<EligibilityFileJobLogModel>(
        'eligibility-file-job-log',
        eligibility_file_job_log_id,
        { include: 'company,eligibility-file-job-log-entries' }
      )
    )) as { content: { data: EligibilityFileJobLogModel } };
    return content.data;
  }
}
